import { FILTER_CONFIG_NAMES } from './DataConstants';

export const getLocationFilterConfig = ({
	filters,
	brandAvailable = false,
	additionalFieldsFilter = null,
}: {
	filters: any;
	brandAvailable?: boolean;
	additionalFieldsFilter?: any;
}) => {
	return [
		filters[FILTER_CONFIG_NAMES.REGION],
		filters[FILTER_CONFIG_NAMES.LOCAATION_TYPE],
		...(brandAvailable ? [filters[FILTER_CONFIG_NAMES.BRAND]] : []),
		...(additionalFieldsFilter ? [additionalFieldsFilter] : []),
		filters[FILTER_CONFIG_NAMES.IS_ACTIVE] && {
			...filters[FILTER_CONFIG_NAMES.IS_ACTIVE],
			showOutsideDropdown: true,
			info: undefined,
		},
	].filter(Boolean);
};
